// src/components/LoadingScreen.js
import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = ({ fadeOut }) => {
  return (
    <div className={`loading-container ${fadeOut ? "fade-out" : ""}`}>
      <h1>With the ❤ of Students of Jee Vision</h1>
      <div className="loading-wave">
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
      </div>

      <p className="rka">
        &lt;/&gt; with ❤ by{" "}
        <a
          href="https://rohan-codes.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Developer Rohan
        </a>
      </p>
    </div>
  );
};

export default LoadingScreen;
